export default __webpack_public_path__ + "static/media/googleplay_es_badge_web.87caab55.png";